import {
  INBOX_START_LOADING_ALL_USERS,
  INBOX_SET_ALL_USERS,
  INBOX_STOP_LOADING_ALL_USERS,
  INBOX_SET_ERROR_LOADING_ALL_USERS,

  INBOX_START_LOADING_MESSAGES,
  INBOX_SET_MESSAGES,
  INBOX_STOP_LOADING_MESSAGES,
  INBOX_SET_ERROR_LOADING_MESSAGES,
  INBOX_SEND_MESSAGE,
  INBOX_ARCHIVE_MESSAGE,
  INBOX_UNARCHIVE_MESSAGE,
  INBOX_SAVE_DRAFT_MESSAGE,

  INBOX_START_LOADING_COMMENTS,
  INBOX_SET_COMMENTS,
  INBOX_STOP_LOADING_COMMENTS,
  INBOX_SET_ERROR_LOADING_COMMENTS,
  INBOX_SEND_COMMENT,
  INBOX_ARCHIVE_COMMENT,
  INBOX_UNARCHIVE_COMMENT,
  INBOX_SAVE_DRAFT_COMMENT,
  
  INBOX_START_LOADING_USERS,
  INBOX_SET_USERS,
  INBOX_STOP_LOADING_USERS,
  INBOX_SET_ERROR_LOADING_USERS,
  INBOX_SAVE_CONTACT,
  INBOX_DELETE_CONTACT,
  
  INBOX_START_LOADING_ALL_GROUPS,
  INBOX_SET_ALL_GROUPS,
  INBOX_STOP_LOADING_ALL_GROUPS,
  INBOX_SET_ERROR_LOADING_ALL_GROUPS,
} from "../Types";
import axios from "axios";


export const getAllUsers = () => (dispatch) => {
  dispatch({ type: INBOX_START_LOADING_ALL_USERS });

  const query = {
    senderId: 0,
    filter: "all",
    keyword: "",
  };

  axios
    .post("/inbox/getUsersList", query)
    .then((response) => {
      dispatch({
        type: INBOX_SET_ALL_USERS,
        users: response.data,
      });
      dispatch({ type: INBOX_STOP_LOADING_ALL_USERS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_ALL_USERS,
        users: [],
        errors: error,
      });
    });
};
export const getAllGroups = () => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_ALL_GROUPS });



  axios
    .get("/inbox/getGroupsList")
    .then((response) => {
      dispatch({
        type: INBOX_SET_ALL_GROUPS,
        groups: response.data,
      });
      dispatch({ type: INBOX_STOP_LOADING_ALL_GROUPS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_ALL_GROUPS,
        users: [],
        errors: error,
      });
    });
};

export const getMessages = (query) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_MESSAGES });

  axios
    .post("/inbox/getMessageList", query)
    .then((response) => {
      dispatch({
        type: INBOX_SET_MESSAGES,
        messages: response.data,
      });
      dispatch({ type: INBOX_STOP_LOADING_MESSAGES });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_MESSAGES,
        messages: [],
        errorsMessages: error,
      });
    });
};

export const sendMessage = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_MESSAGES });

  axios
    .post("/inbox/sendMessage", item)
    .then((response) => {
      dispatch({ type: INBOX_SEND_MESSAGE });
      dispatch({ type: INBOX_STOP_LOADING_MESSAGES });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_MESSAGES,
        messages: [],
        errorsMessages: error
      });
    });
};

export const archiveMessage = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_MESSAGES });

  axios
    .post("/inbox/archiveMessage", item)
    .then((response) => {
      dispatch({ type: INBOX_ARCHIVE_MESSAGE });
      dispatch({ type: INBOX_STOP_LOADING_MESSAGES });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_MESSAGES,
        messages: [],
        errorsMessages: error
      });
    });
};

export const unArchiveMessage = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_MESSAGES });

  axios
    .post("/inbox/unarchiveMessage", item)
    .then((response) => {
      dispatch({ type: INBOX_UNARCHIVE_MESSAGE });
      dispatch({ type: INBOX_STOP_LOADING_MESSAGES });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_MESSAGES,
        messages: [],
        errorsMessages: error
      });
    });
};

export const saveDraftMessage = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_MESSAGES });

  return axios
    .post("/inbox/saveDraftMessage", item)
    .then((response) => {
      dispatch({ type: INBOX_SAVE_DRAFT_MESSAGE, payload: response?.data?.mid});
      dispatch({ type: INBOX_STOP_LOADING_MESSAGES });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_MESSAGES,
        messages: [],
        errorsMessages: error
      });
    });
};

export const getComments = (query) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_COMMENTS });

  axios
    .post("/inbox/getCommentList", query)
    .then((response) => {
      dispatch({
        type: INBOX_SET_COMMENTS,
        comments: response.data,
      });
      dispatch({ type: INBOX_STOP_LOADING_COMMENTS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_COMMENTS,
        comments: [],
        errorsComments: error,
      });
    });
};

export const sendComment = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_COMMENTS });

  return axios
    .post("/inbox/sendComment", item)
    .then((response) => {
      dispatch({ type: INBOX_SEND_COMMENT });
      dispatch({ type: INBOX_STOP_LOADING_COMMENTS });
      return response;
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_COMMENTS,
        comments: [],
        errorsComments: error,
      });
    });
};

export const archiveComment = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_COMMENTS });

  axios
    .post("/inbox/archiveComment", item)
    .then((response) => {
      dispatch({ type: INBOX_ARCHIVE_COMMENT });
      dispatch({ type: INBOX_STOP_LOADING_COMMENTS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_COMMENTS,
        comments: [],
        errorsComments: error,
      });
    });
};

export const unarchiveComment = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_COMMENTS });

  axios
    .post("/inbox/unarchiveComment", item)
    .then((response) => {
      dispatch({ type: INBOX_UNARCHIVE_COMMENT });
      dispatch({ type: INBOX_STOP_LOADING_COMMENTS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_COMMENTS,
        comments: [],
        errorsComments: error,
      });
    });
};

export const saveDraftComment = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_COMMENTS });

  return axios
    .post("/inbox/saveDraftComment", item)
    .then((response) => {
      dispatch({ type: INBOX_SAVE_DRAFT_COMMENT, payload: response?.data?.cid});
      dispatch({ type: INBOX_STOP_LOADING_COMMENTS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_COMMENTS,
        comments: [],
        errorsComments: error,
      });
    });
};

export const getUsers = (query) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_USERS });

  axios
    .post("/inbox/getUsersList", query)
    .then((response) => {
      dispatch({
        type: INBOX_SET_USERS,
        users: response.data,
      });
      dispatch({ type: INBOX_STOP_LOADING_USERS });
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_USERS,
        users: [],
        errors: error
      });
    });
};

export const saveContact = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_USERS });

  return axios
    .post("/inbox/saveContact", item)
    .then((res) => {
      dispatch({ type: INBOX_SAVE_CONTACT });
      dispatch({ type: INBOX_STOP_LOADING_USERS });

      return res;
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_USERS,
        users: [],
        errors: error
      });
    });
};

export const deleteContact = (item) => (dispatch) => {

  dispatch({ type: INBOX_START_LOADING_USERS });

  return axios
    .post("/inbox/deleteContact", item)
    .then((res) => {
      dispatch({ type: INBOX_DELETE_CONTACT });
      dispatch({ type: INBOX_STOP_LOADING_USERS });
      
      return res;
    })
    .catch((error) => {
      dispatch({
        type: INBOX_SET_ERROR_LOADING_USERS,
        users: [],
        errors: error
      });
    });
};